import { getWithStatus } from "./http";

export const getReferralCode = async (code, customerEmail) => {
  try {
    const response = await getWithStatus(
      customerEmail
        ? `/account/referral/${code}/?referred_customer_email=${encodeURIComponent(customerEmail)}`
        : `/account/referral/${code}/`
    );
    if (typeof response.data === "string") {
      return { status: response.status, data: null, error: response.data };
    }
    return { ...response, error: null };
  } catch (error) {
    return { status: 404, data: null, error: "Désolé, une erreur est survenue" };
  }
};
